import { NgModule } from '@angular/core';
import { BiPercentagePipe } from 'app/pipes/bi-percentage.pipe';
import { BIExtraDecodePipe } from 'app/pipes/bi-code-description.pipe';

@NgModule({
  declarations: [BiPercentagePipe, BIExtraDecodePipe],
  exports: [BiPercentagePipe, BIExtraDecodePipe]
})
export class SharedPipesModule {}